import { render, staticRenderFns } from "./CandidateAssessmentComplete.vue?vue&type=template&id=713a817e&scoped=true"
import script from "./CandidateAssessmentComplete.vue?vue&type=script&lang=ts"
export * from "./CandidateAssessmentComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a817e",
  null
  
)

export default component.exports